import { get, post } from "@/api/index";
import request from "@/utils/request";

// 获取个人任务列表
export const getPersonTaskList = (params) =>
  get(`/dapi/task-core/v1/task/personal/list`, params);

// 获取任务列表
export const getTaskList = (params) => {
  let urlStr = "?";
  if ("creatorIds" in params && params.creatorIds.length > 0) {
    urlStr = urlStr + params.creatorIds.map((k) => `creatorIds=${k}`).join("&");
  }
  if ("executorIds" in params && params.executorIds.length > 0) {
    urlStr =
      urlStr +
      "&" +
      params.executorIds.map((k) => `executorIds=${k}`).join("&");
  }
  delete params.executorIds;
  delete params.creatorIds;
  return get(`/dapi/task-core/v1/task/list${urlStr}`, params);
};

// 添加任务
export const addTask = (params) =>
  post(`/dapi/task-core/v1/task/management/add`, params);

// 获取任务详情
export const getTaskDetail = (params) =>
  get(`/dapi/task-core/v1/task/management/detail`, params);

// 修改任务
export const updateTask = (params) =>
  post(`/dapi/task-core/v1/task/management/update`, params);

// 删除任务
export const deleteTask = (params) =>
  post(`/dapi/task-core/v1/task/management/delete`, params);

// 催办任务
export const urgeTask = (params) =>
  post(`/dapi/task-core/v1/task/management/urge`, params);

// 完成任务
export const finishTask = (params) =>
  post(`/dapi/task-core/v1/task/personal/finish`, params);

const base = "/dapi/task-core";
// 获取任务列表
export function taskListApi(params) {
  return request({
    url: `${base}/v1/task/personal/list`,
    method: "get",
    params,
  });
}

/**
 * 完成任务 提交核验
 */
export function finishTaskApi(data) {
  return request({
    url: `${base}/v1/task/personal/finish`,
    method: "post",
    data,
  });
}

// 待办任务统计
export function statisticsApi(params) {
  return request({
    url: `${base}/v1/task/personal/statistics`,
    method: "get",
    params,
  });
}
// 添加好友列表
export function friendTaskListApi(params) {
  return request({
    url: `${base}/v1/task/personal/friendTaskList`,
    method: "get",
    params,
  });
}
// 打卡检核任务详情
export function checkTaskDetailApi(params) {
  return request({
    url: `${base}/v1/task/management/checkTaskDetail`,
    method: "get",
    params,
  });
}
/**
 * 提交反馈自定义任务详情
 */
export function customizeTaskDetailApi(params) {
  return request({
    url: `${base}/v1/task/management/customizeTaskDetail`,
    method: "get",
    params,
  });
}
// 获取手机号
export function getFriendMobileApi(params) {
  return request({
    url: `${base}/v1/task/personal/getFriendMobile`,
    method: "get",
    params,
  });
}
// 添加好友
export function addFriendApi(data) {
  return request({
    url: `${base}/v1/task/personal/addFriend`,
    method: "post",
    data,
  });
}
// cos签名
export function getCosKeyApi(data) {
  return request({
    url: `dapi/b-access-layer/v1/access/knowledge-support-service/v1/support/file/tempKey?dir=task`,
    method: "post",
    data,
  });
}
// 分享用获取内容详情
export function getshareInfoListApi(params) {
  return request({
    url:
      "/dapi/b-access-layer/v1/access/content-management/baiscMaterial/getShareInfoList",
    method: "get",
    params,
  });
}
